import { InjectableHook } from 'domain/types/InjectableHook';

export type IRepositoryAvailabilityHook = InjectableHook<{
  // may be extended to isAvailable(repository): boolean in the future if needed
  isAvailable: boolean;
}>;

export const IRepositoryAvailabilityHook = Symbol('IRepositoryAvailabilityHook');
